<template>
  <el-dialog
      title="选择支付方式"
      :visible.sync="centerDialogVisible"
      :width="width"
      @close="closeDialog"
      center
      class="payment-dialog">
    
    <!-- 支付方式选择 -->
    <div class="payment-methods">
      <div class="method-grid">
        <!-- 支付宝 -->
        <div 
          :class="['payment-method', { active: wayCode=='ALI_PC'||wayCode=='ALI_WAP', disabled: loading }]"
          @click="!loading && (wayCode = label1)">
          <div class="method-icon">
            <svg width="32" height="32" viewBox="0 0 1024 1024" fill="none">
              <path d="M626.999 642c-75.001 90-152.5 145.001-270 145.001S162 714.501 172 627.002c5.001-57.5 45.001-152.5 217.5-137.499 90 7.5 132.501 24.999 207.5 50 20.001-35.001 35.001-75.001 47.499-114.999h-330v-32.5h162.5v-57.5h-197.5v-37.5h197.5v-84.999s2.499-12.5 17.5-12.5h82.5v97.5h210v35.001h-212.5v57.5h172.5c-15.001 65.001-40 125.001-69.999 175.001 42.501 15.001 215.001 67.5 265.001 82.5v-437.5c0-69.999-57.5-125.001-125.001-125.001H214.5c-69.999 0-125.001 57.5-125.001 125.001v605.001c0 69.999 57.5 125.001 125.001 125.001h605.001c69.999 0 125.001-57.5 125.001-125.001v-30c-42.501-20.001-232.5-102.5-317.499-142.5z" fill="#20BDF8"/>
              <path d="M206.999 619.5c-7.5 32.5 12.5 110.001 137.499 110.001 74.999 0 150-47.499 210-124.999-85.001-42.501-155.001-62.5-235.001-62.5-69.999 2.499-104.999 45.001-112.5 77.5z" fill="#20BDF8"/>
            </svg>
          </div>
          <div class="method-info">
            <div class="method-name">支付宝</div>
            <div class="method-desc">安全便捷的在线支付</div>
          </div>
          <div class="method-check">
            <div class="check-circle" :class="{ checked: wayCode=='ALI_PC'||wayCode=='ALI_WAP' }">
              <svg v-if="wayCode=='ALI_PC'||wayCode=='ALI_WAP'" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" fill="white"/>
              </svg>
            </div>
          </div>
        </div>

        <!-- 微信支付 -->
        <div 
          :class="['payment-method', { active: wayCode=='WX_NATIVE'||wayCode=='WX_H5'||wayCode=='WX_JSAPI', disabled: loading }]"
          @click="!loading && (wayCode = label2)">
          <div class="method-icon">
            <svg width="32" height="32" viewBox="0 0 1024 1024" fill="none">
              <path d="M639.2 784.6v0.8c0.1-0.3 0.1-0.6 0.2-0.8 0 0-0.1 0-0.1-0.1 0 0 0 0.1-0.1 0.1 0.1z" fill="#F6AE2F"/>
              <path d="M309 505.3l0.9 1.5c0.1 0 0.1 0 0.2-0.1l-1.1-1.4z" fill="#946728"/>
              <path d="M417.9 606.5c-47.4 26.4-54.5-14.8-54.5-14.8L304 453.3c-22.9-65.7 19.8-29.6 19.8-29.6s36.6 27.6 64.4 44.5c27.8 16.8 59.4 4.9 59.4 4.9l388.7-178.9C764.6 205.2 646.1 147 512 147c-218.8 0-396.2 154.8-396.2 345.8 0 109.9 58.7 207.7 150.2 271l-16.5 94.6s-8 27.6 19.8 14.8c19-8.7 67.4-40 96.2-59.1 45.3 15.7 94.7 24.5 146.4 24.5 218.8 0 396.3-154.8 396.3-345.8 0-55.3-15-107.6-41.4-154C743 413.2 455 585.9 417.9 606.5z" fill="#50B674"/>
            </svg>
          </div>
          <div class="method-info">
            <div class="method-name">微信支付</div>
            <div class="method-desc">微信扫码快速支付</div>
          </div>
          <div class="method-check">
            <div class="check-circle" :class="{ checked: wayCode=='WX_NATIVE'||wayCode=='WX_H5'||wayCode=='WX_JSAPI' }">
              <svg v-if="wayCode=='WX_NATIVE'||wayCode=='WX_H5'||wayCode=='WX_JSAPI'" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" fill="white"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 二维码显示区域 -->
    <div v-if="codeUrl && current===wayCode" class="qr-code-section">
      <div class="qr-container">
        <img :src="codeUrl" alt="支付二维码" class="qr-code" />
      </div>
      <div class="qr-tip">
        <h3>请使用手机扫码支付</h3>
        <p>打开支付宝或微信扫一扫</p>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="centerDialogVisible = false" class="cancel-btn" :disabled="loading">取 消</el-button>
      <el-button 
        type="primary" 
        @click="topay" 
        class="confirm-btn"
        :loading="loading"
        :disabled="loading">
        {{ loading ? '处理中...' : '确认支付' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
const isMobileDevice=() =>{
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // 检查用户代理字符串
  return /android|iPhone|iPad|iPod|windows phone|blackberry|iemobile|opera mini/i.test(userAgent);
}

const QRCode = require('qrcode');
// 检查支付状态
let checkTimer = null;
export default {
  data() {
    return {
      centerDialogVisible: false,
      wayCode:'',
      busId:'',
      busType:'',
      codeUrl:'',
      current:'',
      num:1,
      loading: false
    };
  },
  computed:{
    width(){
      if(isMobileDevice()) return  '100%'
      return '40%'
    },
    label1(){
      if(isMobileDevice()) return  'ALI_WAP'
      return 'ALI_PC'
    },
    label2(){
      if(isMobileDevice()) return  'WX_JSAPI'
      return 'WX_NATIVE'
    }
  },
  watch: {
    wayCode: {
      handler(newCount, oldCount) {
      },
      immediate: true
    }
  },
  methods: {
    topay(){
      if(!this.wayCode) {
        this.$message.warning('请选择支付方式');
        return;
      }
      
      this.loading = true;
      
      if(this.wayCode=="WX_JSAPI"){ //手机端直接微信内支付
        this.current=this.wayCode;
        QRCode.toDataURL("https://www.zsgeek.cn/#/pay/"+this.busId,  (error, url) =>{
          this.loading = false;
          if (error) {
            console.error('生成二维码失败:', error);
            this.$message.error('生成二维码失败');
          }
          console.log('二维码的 Base64:', url);
          if(url)
            this.codeUrl=url
        });
        return
      }
      
      this.$http2({
        url: `/pay?busId=${this.busId}&busType=${this.busType}&wayCode=${this.wayCode}&num=${this.num}`,
        method: 'get'
      }).then((res) => {
        this.loading = false;
        this.current=this.wayCode;
        if(res.data.mchOrderNo){
          this.checkstate(res.data.mchOrderNo);
        }
        if(res.data.payDataType=='payurl')
          window.open(res.data.payData,'_blank')
        if(res.data.payDataType=='codeUrl'){
          QRCode.toDataURL(res.data.payData,  (error, url) =>{
            if (error) {
              console.error('生成二维码失败:', error);
              this.$message.error('生成二维码失败');
            }
            console.log('二维码的 Base64:', url);
            if(url)
            this.codeUrl=url
          });
        }

      }).catch((error) => {
        this.loading = false;
        console.error('支付请求失败:', error);
        this.$message.error('支付请求失败，请重试');
      })

    },
    /**
     * 支付
     * @param busId 业务id
     * @param busType 业务类型
     * @param num 购买数量
     */
    openPay(busId,busType,num=1){
      this.busId=busId;
      this.busType=busType;
      this.num=num;
      this.centerDialogVisible=true;
    },
    closeDialog(){
      console.log("关闭")
      if(checkTimer){
        clearInterval(checkTimer);
      }
      this.codeUrl='';
    },
    checkstate(mchOrderNo){
      if(checkTimer) clearInterval(checkTimer)
      checkTimer = setInterval( () => {
        this.$http2({
          url: `/pay/check?mchOrderNo=${mchOrderNo}`,
          method: 'get'
        }).then((res) => {
          console.log(res)
          if(res.data){
            this.$emit('paySuccess', mchOrderNo);
            clearInterval(checkTimer);
            this.centerDialogVisible=false;
          }
        })
      }, 3000); // 每3秒检查一次

    }
  }
};
</script>
<style scoped lang="scss">
/* 支付对话框样式 */
.payment-dialog {
  :deep(.el-dialog) {
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
    
    .el-dialog__header {
      background: linear-gradient(135deg, #ff6b00 0%, #ff8124 100%);
      color: white;
      padding: 24px 30px;
      
      .el-dialog__title {
        font-size: 20px;
        font-weight: 600;
      }
      
      .el-dialog__headerbtn {
        .el-dialog__close {
          color: white;
          font-size: 20px;
          
          &:hover {
            color: rgba(255, 255, 255, 0.8);
          }
        }
      }
    }
    
    .el-dialog__body {
      padding: 30px;
    }
    
    .el-dialog__footer {
      padding: 20px 30px;
      border-top: 1px solid #f0f0f0;
      background: #fafafa;
    }
  }
}

/* 支付方式选择区域 */
.payment-methods {
  margin-bottom: 30px;
  
  .method-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }
}

/* 支付方式卡片 */
.payment-method {
  display: flex;
  align-items: center;
  padding: 20px;
  border: 2px solid #e8e8e8;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: white;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #ff6b00 0%, #ff8124 100%);
    transform: scaleX(0);
    transition: transform 0.3s ease;
  }
  
  &:hover:not(.disabled) {
    border-color: #ff6b00;
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(255, 107, 0, 0.15);
    
    &::before {
      transform: scaleX(1);
    }
  }
  
  &.active {
    border-color: #ff6b00;
    background: linear-gradient(135deg, rgba(255, 107, 0, 0.05) 0%, rgba(255, 129, 36, 0.05) 100%);
    
    &::before {
      transform: scaleX(1);
    }
    
    .method-icon {
      transform: scale(1.1);
    }
    
    .check-circle {
      background: #ff6b00;
      border-color: #ff6b00;
    }
  }
  
  &.disabled {
    cursor: not-allowed;
    opacity: 0.6;
    
    &:hover {
      transform: none;
      box-shadow: none;
    }
    
    .method-icon {
      filter: grayscale(1);
    }
  }
  
  .method-icon {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    background: #f8f9fa;
    margin-right: 16px;
    transition: all 0.3s ease;
    
    svg {
      filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
    }
  }
  
  .method-info {
    flex: 1;
    
    .method-name {
      font-size: 16px;
      font-weight: 600;
      color: #333;
      margin-bottom: 4px;
    }
    
    .method-desc {
      font-size: 12px;
      color: #666;
      line-height: 1.4;
    }
  }
  
  .method-check {
    margin-left: 12px;
    
    .check-circle {
      width: 24px;
      height: 24px;
      border: 2px solid #ddd;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;
      
      &.checked {
        background: #ff6b00;
        border-color: #ff6b00;
        animation: checkPulse 0.3s ease;
      }
      
      svg {
        width: 12px;
        height: 12px;
      }
    }
  }
}

/* 二维码区域 */
.qr-code-section {
  text-align: center;
  padding: 30px 0;
  border-top: 1px solid #f0f0f0;
  margin-top: 20px;
  
  .qr-container {
    position: relative;
    display: inline-block;
    margin-bottom: 20px;
    
    .qr-code {
      width: 200px;
      height: 200px;
      border-radius: 12px;
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
      border: 4px solid white;
    }
    
    .qr-overlay {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 60px;
      height: 60px;
      background: rgba(255, 255, 255, 0.95);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
      
      .qr-icon {
        color: #ff6b00;
        animation: qrPulse 2s infinite;
      }
    }
  }
  
  .qr-tip {
    h3 {
      font-size: 18px;
      font-weight: 600;
      color: #333;
      margin: 0 0 8px;
    }
    
    p {
      font-size: 14px;
      color: #666;
      margin: 0;
    }
  }
}

/* 按钮样式 */
.dialog-footer {
  .cancel-btn {
    border: 1px solid #ddd;
    color: #666;
    border-radius: 8px;
    padding: 12px 24px;
    font-weight: 500;
    transition: all 0.3s ease;
    
    &:hover:not(:disabled) {
      border-color: #ff6b00;
      color: #ff6b00;
      background: rgba(255, 107, 0, 0.05);
    }
    
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
  
  .confirm-btn {
    background: linear-gradient(135deg, #ff6b00 0%, #ff8124 100%);
    border: none;
    border-radius: 8px;
    padding: 12px 32px;
    font-weight: 600;
    box-shadow: 0 4px 15px rgba(255, 107, 0, 0.3);
    transition: all 0.3s ease;
    
    &:hover:not(:disabled) {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(255, 107, 0, 0.4);
    }
    
    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
      transform: none;
    }
    
    &.is-loading {
      .el-loading-spinner {
        .circular {
          width: 16px;
          height: 16px;
        }
      }
    }
  }
}

/* 动画效果 */
@keyframes checkPulse {
  0% {
    transform: scale(0.8);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes qrPulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .payment-dialog {
    :deep(.el-dialog) {
      margin: 10px;
      width: calc(100% - 20px) !important;
      
      .el-dialog__body {
        padding: 20px;
      }
      
      .el-dialog__footer {
        padding: 15px 20px;
      }
    }
  }
  
  .payment-method {
    padding: 16px;
    
    .method-icon {
      width: 40px;
      height: 40px;
      margin-right: 12px;
    }
    
    .method-info {
      .method-name {
        font-size: 14px;
      }
      
      .method-desc {
        font-size: 11px;
      }
    }
  }
  
  .qr-code-section {
    .qr-container {
      .qr-code {
        width: 160px;
        height: 160px;
      }
      
      .qr-overlay {
        width: 50px;
        height: 50px;
      }
    }
  }
}

/* 支付宝特殊样式 */
.payment-method:first-child {
  .method-icon {
    background: linear-gradient(135deg, #20BDF8 0%, #1E88E5 100%);
    
    svg {
      filter: brightness(0) invert(1);
    }
  }
}

/* 微信支付特殊样式 */
.payment-method:last-child {
  .method-icon {
    background: linear-gradient(135deg, #50B674 0%, #4CAF50 100%);
    
    svg {
      filter: brightness(0) invert(1);
    }
  }
}
</style>